import { ModuleKey, RoleKey, checkRoleKey } from '@nxtpeople/nxt-vue-library';
import { createStore } from 'vuex';
import modules from './collections';
import { StoreState } from './models/store.interface';

const store = createStore<StoreState>({
   state: {
      env: import.meta.env.VITE_APP_ENV,
      navBarZIndex: `calc(var(--zindex-fixed) + 2)`,
      viewedIds: { candidate: [], customer: [], position: [], communication: [] },
   },
   getters: {
      isDev(state) {
         return state.env === 'dev';
      },
      isDeveloper(state) {
         return checkRoleKey(RoleKey.Developer, ModuleKey.NxtMatch, state.userInfo?.userInfo?.roles || []);
      },
      isFeatureTester(state) {
         return checkRoleKey(RoleKey.FeatureTester, ModuleKey.NxtMatch, state.userInfo?.userInfo?.roles || []);
      },
      isLite(state) {
         return !(
            checkRoleKey(RoleKey.TenantConsultant, ModuleKey.NxtMatch, state.userInfo?.userInfo?.roles || []) ||
            checkRoleKey(RoleKey.TenantAdmin, ModuleKey.NxtMatch, state.userInfo?.userInfo?.roles || [])
         );
      },
      userinfoTeamCountry(state) {
         return state.userInfo?.userInfo?.default_team?.city?.country.iso_code_2.toUpperCase() || 'BE';
      },
   },
   mutations: {
      SET_NAVBAR_ZINDEX(state, value: string) {
         state.navBarZIndex = value;
      },
      ADD_VIEWED_ID(state, { type, id }: { type: 'candidate' | 'customer' | 'position' | 'communication'; id: number }) {
         if (!state.viewedIds[type]) {
            state.viewedIds[type] = [];
         }
         if (!state.viewedIds[type].includes(id)) {
            state.viewedIds[type].push(id);
         }
      },
      REMOVE_VIEWED_ID(state, { type, id }: { type: 'candidate' | 'customer' | 'position' | 'communication'; id: number }) {
         if (!state.viewedIds[type]) return;
         const index = state.viewedIds[type].findIndex((i) => i === id);
         if (index > -1) {
            state.viewedIds[type].splice(index, 1);
         }
      },
      CLEAR_VIEWED_IDS(state) {
         state.viewedIds = { candidate: [], customer: [], position: [], communication: [] };
      },
   },
   actions: {},
   modules,
});

export default store;
